import { AwaitResponse } from '@general/js/utils/MockUtils';
import AbstractClass from './SupportAbstractServices';

export default class SupportServices extends AbstractClass {
  static getContactUsReferenceData() {
    const mockData = {
      contactUsInformationText: {
        informationText:
          '<p>Got a question? Can&rsquo;t find what you are looking for?</p>\r\n\r\n<p>Tell us how we can help you, send us a message using the form below.</p>\r\n\r\n<p>We already have your contact details. If these are incorrect, please update your information within Member Details.</p>\r\n',
      },
      businessHoursInformationText: {
        informationText: 'Our friendly team are available to chat online within the business hours below.',
      },
      contactUsAboutOptions: [
        {
          display: 'I have feedback or a complaint for Defence Health',
          returnValue: 'FeedbackComplaint',
        },
        {
          display: 'I want to make an update/change to my policy',
          returnValue: 'Update',
        },
        {
          display: 'I have questions about using my policy to claim',
          returnValue: 'Policy',
        },
        {
          display: 'I have a question about an Extras claim',
          returnValue: 'Extras',
        },
        {
          display: 'I have a question about a Hospital Claim',
          returnValue: 'Hospital',
        },
        {
          display: 'I have a question about a provider',
          returnValue: 'Provider',
        },
        {
          display: 'I have a question about my cover',
          returnValue: 'Cover',
        },
        {
          display: 'I want to suspend/reinstate my cover',
          returnValue: 'Suspend',
        },
        {
          display: 'I have a question about premiums/a payment',
          returnValue: 'Payment',
        },
        {
          display: 'I have a question about going to hospital',
          returnValue: 'QAHospital',
        },
        {
          display: 'Other',
          returnValue: 'OtherPortal',
        },
      ],
      contactByOptions: [
        {
          display: 'Email',
          returnValue: 'Email',
        },
        {
          display: 'Phone',
          returnValue: 'Phone',
        },
      ],
      section1Title: {
        informationText: 'Need help with Health Insurance?',
      },
      section1DescriptionText: {
        informationText: '<p>For a quick response, chat to one of our friendly staff or send us a message using the form above.</p>',
      },
      section1AccordionHeading1: {
        informationText: 'Health insurance',
      },
      section1Accordion1Text: {
        informationText:
          '<p>Talk to us&nbsp;<a href="tel:1800335425">1800 335 425</a><br />\r\n(international&nbsp;<a href="tel:+61386791000">+613 8679 1000</a>)<br />\r\nMonday - Thursday 8:30am - 8:00pm<br />\r\nFriday 8:30am - 6:00pm AEST/AEDT</p>\r\n\r\n<p><strong>Mail</strong></p>\r\n\r\n<p>PO Box 7518, Melbourne VIC 3004</p>\r\n\r\n<p><strong>Visit</strong></p>\r\n\r\n<p>Level 7, 380 St Kilda Road, Melbourne VIC 3004</p>\r\n\r\n<p><strong>Fax</strong></p>\r\n\r\n<p>General enquiries&nbsp;<a href="tel:1300665096">1300 665 096</a>&nbsp;(international&nbsp;<a href="tel:+61386791010">+613 8679 1010</a>)<br />\r\nClaims&nbsp;<a href="tel:1800241581">1800 241 581</a></p>\r\n',
      },
      section1AccordionHeading2: {
        informationText: 'Travel insurance',
      },
      section1Accordion2Text: {
        informationText:
          '<p>Talk to Allianz&nbsp;<a href="tel:1800622499">1800 622 499</a></p>\r\n\r\n<p><strong>Email</strong></p>\r\n\r\n<p><a href="mailto:defencehealthtravel@allianz-assistance.com.au">defencehealthtravel@allianz-assistance.com.au</a></p>',
      },
      section1AccordionHeading3: {
        informationText: 'Life and accident insurance',
      },
      section1Accordion3Text: {
        informationText:
          '<p>For a quick response, chat to one of our friendly staff or send us a message using the form above</p>\r\n\r\n<p>While we are no longer accepting applications for life, accident or trauma insurance, we continue to support existing policy holders of these products.</p>\r\n\r\n<p>Talk to us&nbsp;<a href="tel:1800676465">1800 676 465</a><br />\r\nMonday - Friday, 8:30am - 5:00pm AEST/AEDT</p>\r\n\r\n<p>Talk to AIG&nbsp;<a href="tel:1800331610">1800 331 610</a><br />\r\n(International&nbsp;<a href="tel:+61395224000">+613 9522 4000</a>) for Accident insurance claims (D-Pax)</p>\r\n\r\n<p>&nbsp;</p>',
      },
      section2Title: {
        informationText: 'Would you like to give a compliment or make a complaint?',
      },
      section2LeftText: {
        informationText:
          '<p>You are a valued member of our family. If we&rsquo;ve got something wrong, let us know so we can make it right. We especially love to hear when we have delighted you, so let us know when we get it right too!</p>\r\n\r\n<p>For a quick response, chat to one of our friendly staff or send us a message using the form above.</p>\r\n\r\n<p>Talk&nbsp;to us on&nbsp;<a href="tel:1800335425">1800 335 425</a><br />\r\nEmail&nbsp;<a href="mailto:info@defencehealth.com.au">info@defencehealth.com.au</a>&nbsp;</p>\r\n\r\n<p>We&rsquo;re committed to resolving any complaints as quickly as we can and have an issues and complaints handling system to help us do that every time.</p>\r\n<h3 id="request-an-independent-review-for-health-insurance">Request an independent review for Health Insurance</h3>\r\n\r\n<p>If we are unable to satisfy your concern, you can request an independent review.</p>\r\n\r\n<p>Lodge an enquiry with the Commonwealth Ombudsman at <a href="https://www.ombudsman.gov.au/contact">https://www.ombudsman.gov.au/contact</a></p>\r\n\r\n<p><br />\r\nTalk to the Commonwealth Ombudsman on&nbsp;<a href="tel:1300362072" rel="noopener noreferrer" target="_blank">1300 362 072</a></p>\r\n\r\n<p>For general information about private health insurance, see&nbsp;<a href="http://www.privatehealth.gov.au/" rel="noopener noreferrer" target="_blank">www.privatehealth.gov.au</a></p>\r\n\r\n<h3 id="request-an-independent-review-of-life-general-or-travel-insurance">Request an independent review of Life, General or Travel Insurance</h3>\r\n\r\n<p>If we are unable to satisfy your concern, you can request an independent review.</p>\r\n\r\n<p>Lodge an enquiry with the Australian Financial Complaints Authority at&nbsp;<a href="https://www.afca.org.au/make-a-complaint/">https://www.afca.org.au/make-a-complaint/</a>&nbsp;</p>\r\n\r\n<p>Talk to the Australian Financial Complaints Authority on&nbsp;<a href="tel:1800931678">1800 931 678</a></p>\r\n',
      },
    };
    return AwaitResponse(JSON.parse(JSON.stringify(mockData).tokenSwap()));
  }

  static getContactUsConfirmationReferenceData() {
    const mockData = {
      relatedArticle1: {
        heading: 'How do I choose hospital cover?',
        toUrl: 'https://healthhq.defencehealth.com.au/2019/04/30/how-do-i-choose-hospital-cover/',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2019/04/How-do-I-choose-hospital-cover-1024x683.jpg',
        imageAltText: 'family image',
        tag: 'Family',
        listedTime: '2021-09-08T10:25:26',
      },
      relatedArticle2: {
        heading: 'Keeping your cover affordable',
        toUrl: 'https://healthhq.defencehealth.com.au/2016/02/19/keeping-your-cover-affordable/',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2016/02/Lady-on-Laptop-affordability-resized-1024x683.jpg',
        imageAltText: 'person on laptop',
        tag: 'Affordable',
        listedTime: '2021-09-08T10:25:27',
      },
      relatedArticle3: {
        heading: 'Make the most out of your health care',
        toUrl: 'https://healthhq.defencehealth.com.au/2016/08/31/make-health-care/',
        imageUrl: 'https://healthhq.defencehealth.com.au/wp-content/uploads/2016/08/Image-Benefits-of-PHI.jpg',
        imageAltText: 'hospital',
        tag: 'Wellness',
        listedTime: '2021-09-08T10:25:28',
      },
    };
    return AwaitResponse(JSON.parse(JSON.stringify(mockData).tokenSwap()));
  }
}
